<route>
{
    "name": "reports-account-report",
    "meta": {
        "title": "Raport conturi",
        "requiresAuth": true,
        "permissions": ["manager", "sef_de_unitate", "secretar"],
        "fail": "/403"
    }
}
</route>
<template>
    <company-layout>
        <v-container fluid grid-list-xl>
            <v-row>
                <v-col>
                    <v-card :loading="loading">
                        <template slot="progress">
                            <v-overlay absolute class="d-flex flex-column text-center">
                                <div>
                                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                                        <span>In curs de incarcare...</span>
                                    </v-progress-circular>
                                </div>
                            </v-overlay>
                        </template>
                        <v-card-title>
                            Raport conturi
                            <v-spacer></v-spacer>
                            <v-select
                                :items="Static.accounts"
                                item-text="name"
                                item-value="id"
                                v-model="account"
                                :style="{maxWidth:'300px', maxHeight: '40px'}"
                                placeholder="Cont"
                                label="Cont"
                                class="primary--text"
                                name="account"
                                clearable
                                solo
                                dense
                            ></v-select>
                            <v-menu
                                ref="menu"
                                v-model="periodMenu"
                                :close-on-content-click="false"
                                :return-value.sync="period"
                                transition="scale-transition"
                                offset-y
                                class="py-0"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        v-bind="attrs"
                                        v-on="on">
                                        Perioada {{ periodText }}
                                    </v-btn>
                                </template>
                                <v-date-picker
                                    v-model.lazy="period"
                                    range
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="periodMenu = false"
                                    >
                                        Anulare
                                    </v-btn>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.menu.save(period)"
                                    >
                                        Filtrare
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-card-title>
                        <v-card-text>

                            <v-row>
                                <v-col cols="12">
                                    <bar-chart :chart-data="getDailyChartData" :options="getDailyChartOptions" :height="100"></bar-chart>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3">
                                    <doughnut :chart-data="getChartData"></doughnut>
                                </v-col>
                                <v-col cols="9">
                                    <v-simple-table dense>
                                        <template v-slot:default>
                                            <thead>
                                            <tr>
                                                <th>
                                                    Sursa
                                                </th>
                                                <th>
                                                    Destinatie
                                                </th>
                                                <th>
                                                    Descriere
                                                </th>
                                                <th class="text-right">
                                                    Valoare
                                                </th>
                                                <th class="text-right">
                                                    Data
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(item, index) in paymentTransactions" :key="index">
                                                <td>
                                                    <payment-transaction-source :item="item"></payment-transaction-source>
                                                </td>
                                                <td>
                                                    <payment-transaction-destination :item="item"></payment-transaction-destination>
                                                </td>
                                                <td>
                                                    {{ _.get(item, 'payment.document_no', '') }}<br/>
                                                    {{ _.get(item, 'payment.remarks', 'Nedefinit') }}<br/>
                                                </td>
                                                <td class="text-right">
                                                    {{ item.amount | price }}
                                                </td>
                                                <td class="text-right">
                                                    <template v-if="!_.isNil(item.payment.payment_date)">
                                                    {{ new Date(item.payment.payment_date) | shortdate }}
                                                    </template>
                                                    <template v-else>
                                                        -
                                                    </template>
                                                </td>
                                            </tr>
                                            </tbody>
                                            <tfoot>
                                            <tr v-if="category !== '0'">
                                                <td colspan="4">
                                                    <v-btn x-small block @click="category = '0'">
                                                        Inapoi
                                                    </v-btn>
                                                </td>
                                            </tr>
                                            </tfoot>
                                        </template>
                                    </v-simple-table>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </company-layout>
</template>

<script>
    import CompanyLayout from "Layouts/Company.vue";
    import BarChart from "Components/reports/Bar.vue";
    import Doughnut from "Components/reports/Doughnut.vue";
    import PaymentTransactionSource from "Components/reports/Common/PaymentTransactionSource.vue";
    import PaymentTransactionDestination from "Components/reports/Common/PaymentTransactionDestination.vue";

    export default {
        components: {
            CompanyLayout,
            Doughnut,
            BarChart,
            PaymentTransactionSource,
            PaymentTransactionDestination
        },
        data () {
            return {
                loading: true,
                category: '0',
                period: [window.moment().subtract(1, 'month').toISOString(), window.moment().toISOString()],
                periodMenu: false,
                paymentTransactions: [],
                accountData: undefined,
                account: undefined
            }
        },
        computed: {
            periodText () {
                return this.period.map(item => this.$options.filters.date(new Date(item))).join(' ~ ')
            },
            getChartData () {
                var transactions = this.paymentTransactions.map((transaction) => {
                    transaction.amount = parseFloat(transaction.amount)
                    return transaction
                })
                var expenses = transactions.filter(transaction => transaction.amount < 0)
                var revenue = transactions.filter(transaction => transaction.amount > 0)
                return {
                    datasets: [{
                        data: [this._.sumBy(revenue, 'amount'), this._.sumBy(expenses, 'amount')],
                        backgroundColor: [this.colorScheme[0], this.colorScheme[1]]
                    }],
                    labels: ['Venituri', 'Cheltuieli']
                }
            },
            getDailyChartData () {
                var transactions = this.paymentTransactions.map((transaction) => {
                    transaction.amount = parseFloat(transaction.amount)
                    return transaction
                })
                var transactionGroups = this._.groupBy(transactions, (transaction) => {
                    return transaction?.payment?.payment_date
                })
                var revenueGroups = Object.values(transactionGroups).map((group) => {
                    return this._.sumBy(group.filter(transaction => transaction.amount > 0), 'amount')
                })
                var expenseGroups = Object.values(transactionGroups).map((group) => {
                    return this._.sumBy(group.filter(transaction => transaction.amount < 0), 'amount')
                })
                return {
                    datasets: [{
                        data: revenueGroups,
                        backgroundColor: this.colorScheme[0],
                        label: 'Venit'
                    }, {
                        data: expenseGroups,
                        backgroundColor: this.colorScheme[1],
                        label: 'Cheltuieli'
                    }],
                    labels: Object.keys(transactionGroups)
                }
            },
            getDailyChartOptions() {
                return {
                    barValueSpacing: 20
                }
            },
        },
        watch: {
            period: {
                async handler(val) {
                    await this.fetchData()
                }
            },
            account: {
                async handler(val) {
                    await this.fetchData()
                }
            }
        },
        async mounted() {
            await this.fetchData()
        },
        methods: {
            async fetchData () {
                if(this.period.length !== 2) return
                this.loading = true
                var paymentTransactions = this.$db.PaymentTransaction
                    .include(
                        'payment',
                        'payment.accountable.customer',
                        'payment.subject',
                        'payment.payer'
                    )
                    .where('between', [window.moment(this.period[0]).format('YYYY-MM-DD'), window.moment(this.period[1]).format('YYYY-MM-DD')].join(','))

                if(this.account !== undefined) {
                    this.accountData = await this.$db.Account.find(this.account).then(({data}) => data)
                    paymentTransactions = paymentTransactions.where('account_involved', this.account)
                } else {
                    this.accountData = undefined
                }

                await paymentTransactions
                    .limit(2500)
                    .get()
                    .then(({data}) => {
                        this.paymentTransactions = data.sort(function(a, b) {
                            return new Date(b?.payment?.payment_date) - new Date(a?.payment?.payment_date);
                        })
                    }).catch((err) => {
                        console.error(err)
                    }).finally(() => {
                        this.loading = false
                    })
            }
        }
    };
</script>
